import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API, apiError } from "@/lib/api";
import { MailWarning } from "lucide-react";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [emailEnabled, setEmailEnabled] = useState(null); // null = verifica in corso

  useEffect(() => {
    API.get("/config")
      .then((r) => setEmailEnabled(!!r.data.password_reset_email))
      .catch(() => setEmailEnabled(false));
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await API.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-900 px-4">
      <div className="w-full max-w-md rounded-xl border border-slate-700 bg-white p-8 shadow-2xl">
        <h1 className="mb-2 text-2xl font-extrabold tracking-tight">Password dimenticata</h1>
        {emailEnabled === null ? (
          <p className="text-sm text-muted-foreground">Verifica configurazione…</p>
        ) : emailEnabled === false ? (
          <div data-testid="forgot-unavailable" className="rounded-lg border border-amber-300 bg-amber-50 px-4 py-4 text-sm text-amber-900">
            <div className="mb-2 flex items-center gap-2 font-bold">
              <MailWarning size={18} /> Recupero via email non disponibile in questo ambiente
            </div>
            <p>
              Il servizio di invio email non è configurato: nessuna mail verrebbe realmente inviata, quindi il modulo è disattivato
              per non illuderti.
            </p>
            <p className="mt-2">
              Per cambiare la password: accedi e usa <strong>Cambia password</strong> nell'intestazione in alto, oppure contatta
              l'amministratore.
            </p>
          </div>
        ) : done ? (
          <div data-testid="forgot-password-success" className="rounded-lg border border-teal-300 bg-teal-50 px-4 py-3 text-sm font-semibold text-teal-800">
            Se l'indirizzo è registrato, abbiamo inviato un link di reimpostazione.
          </div>
        ) : (
          <>
            <p className="mb-6 text-sm text-muted-foreground">Inserisci l'email dell'account magazzino.</p>
            <form onSubmit={submit} className="space-y-4">
              <input
                data-testid="forgot-email"
                type="email"
                required
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="h-12 w-full rounded-lg border border-input px-4 text-base outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20"
                placeholder="nome@azienda.it"
              />
              {error && (
                <div data-testid="forgot-error" className="rounded-lg border border-rose-300 bg-rose-50 px-4 py-3 text-sm font-semibold text-rose-800">
                  {error}
                </div>
              )}
              <button
                data-testid="forgot-submit"
                type="submit"
                disabled={loading}
                className="h-12 w-full rounded-lg bg-blue-600 text-base font-bold text-white transition-colors hover:bg-blue-700 disabled:opacity-60"
              >
                {loading ? "Invio…" : "Invia link di reimpostazione"}
              </button>
            </form>
          </>
        )}
        <div className="mt-4 text-center">
          <Link to="/login" data-testid="back-to-login" className="text-sm font-semibold text-blue-600 hover:underline">
            Torna al login
          </Link>
        </div>
      </div>
    </div>
  );
}
